<template>
    <div class="radio-group">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: ['value', 'name']
}
</script>